




















































import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

export default Vue.extend({
    name: "App",
    props: {
        source: String
    },

    components: {},

    data: () => ({
        drawer: null
        //
    })
});
